<template>
  <div class="l-contentmain contentmain">
    <page-nav-bar
      v-if="group"
      :is-sticky="true"
      :back-button="true"
      :has-actions="!group.protected">
      <template slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          <router-link :to="{ name: 'GroupListInterne' }">
            Groupes
          </router-link>
        </h1>

        <div class="page-header-breadcrumb-separator"></div>
        <div
          class="page-header-breadcrumb-item"
          v-if="group && group.name">
          <span class="has-text-weight-normal has-text-grey-dark">{{ group.name }}</span>
        </div>
      </template>
      <a
        v-if="!group.protected"
        slot="dropdown-content"
        class="dropdown-item has-background-danger has-text-white"
        @click="removeGroup">
        <span class="icon is-medium"><i class="fas fa-trash-alt"></i></span><span class="is-margin-left-xsmall">Supprimer</span>
      </a>
    </page-nav-bar>
    <spinner-round
      :is-loading="loading"
      v-if="loading"></spinner-round>
    <page-content
      v-else-if="group && !loading"
      :has-left-col-small="true"
      :has-left-col-small-size-fixed="true"
      :has-sticky-col-left="true">
      <template slot="left-col-small">
        <div class="has-background-white is-border">
          <div class="is-padding-top is-padding-left is-padding-right is-padding-bottom-small has-text-centered">
            <figure class="image is-128x128 is-margin-auto has-vadPicto has-picto--top2Right">
              <div class="is-border is-border--circle is-clipped">
                <div
                  class="has-text-white is-clipped is-size-1 is-relative has-background-light--darken2"
                  style="width: 126px; height: 126px; line-height: 126px;">
                  {{ group.name[0] | cap }}{{ group.name[1] | cap }}
                </div>
              </div>
            </figure>
            <div
              v-if="group && group.name"
              class="title is-3 is-margin-top-xsmall is-marginless-bottom">
              <b>{{ group.name }}</b>
            </div>
          </div>
          <div class="is-border-top is-border--dashed">
            <div class="columns is-multiline is-gapless">
              <div
                @click="tab === 'MEMBRES'"
                class="column is-6 is-border-bottom is-border-right is-border--dashed columns is-column is-space-between is-padding-top-small is-padding-bottom-small is-padding-left is-padding-right">
                <div class="has-text-grey is-size-6">
                  Membre(s) du groupe
                </div>
                <div> {{ group.users.length }} </div>
              </div>
            </div>
          </div>
        </div>
        <event-tracker-list :field="'group'"></event-tracker-list>
      </template>
      <div class="has-background-white is-border">
        <tabs
          :links="groupTabLinks"
          :current-tab="tab"
          @changeView="tab = $event"
          mode="emitter"
          class="is-border-bottom"></tabs>
        <div
          v-if="tab === 'MEMBRES'"
          class="is-padding">
          <div :class="{'is-paddingless-bottom': group.users && group.users.length}">
            <r-label
              :is-required="false"
              :label="'Membre(s) du groupe'">
              <span class="tag has-text-weight-normal is-small is-primary is-margin-left-xsmall">{{ group.users.length }}</span>
            </r-label>
            <div
              class="column is-12 columns is-multiline"
              v-if="group.users && !group.users.length">
              <div class="notification is-warning is-radius-large is-padding-small">
                <p class="is-margin-right">
                  <i class="fal fa-comment-alt-exclamation fa-lg is-inline-block is-vcentered is-margin-right-xsmall"></i>
                  <span>Aucun membre dans le groupe<br></span>
                </p>
              </div>
            </div>
            <a
              v-if="!group.protected"
              @click.prevent.stop="openAddNewMember"
              class="columns is-vcentered is-gapless is-border is-padding-small has-link-grey">
              <div class="column">
                <div class="is-uppercase">
                  <avatar
                    :force-picto="true"
                    :use-picto-custom="'fal fa-user-plus'"
                    :is-avatar="false"
                    class="is-border is-medium"></avatar>

                  <span class="is-margin-left-small">Ajouter un Membre</span>
                </div>
              </div>
            </a>
          </div>
          <div
            class="is-padding-top"
            v-if="group.users && group.users.length">
            <div
              class="columns is-vcentered is-gapless is-border is-padding-small"
              v-for="(user, i) in group.users"
              :key="user.pk">
              <div class="column columns is-gapless">
                <div class="column is-vcentered columns">
                  <avatar
                    v-if="group.is_commercial"
                    :item="user.account"
                    :i="i"
                    class="is-medium"></avatar>
                  <avatar
                    v-else
                    :item="user"
                    :i="i"
                    class="is-medium"></avatar>
                  <div
                    v-if="group.is_commercial"
                    class="is-margin-left-small">
                    <div class="title is-3">
                      <router-link :to="{name: 'UserVue', params: {id: user.pk}}">
                        <b>{{ user.account.name }}</b>
                      </router-link>
                      <br>
                      <span class="has-text-grey is-size-6 has-text-weight-normal">Referent : </span>
                      <span class="is-size-5 has-text-weight-normal">{{ user.first_name }} {{ user.last_name }}</span>
                      <span class="has-text-grey is-size-6 has-text-weight-normal"> / {{ user.email }}</span>
                    </div>
                  </div>
                  <div
                    v-else
                    class="is-margin-left-small">
                    <div class="title is-4">
                      <router-link :to="{name: 'UserVue', params: {id: user.pk}}">
                        <b>{{ user.first_name }} {{ user.last_name }}</b>
                      </router-link>
                      <span class="has-text-grey is-size-5 has-text-weight-normal"> / {{ user.email }}</span>
                    </div>
                  </div>
                </div>
                <div
                  v-if="!group.protected"
                  class="column is-narrow has-text-right">
                  <button
                    class="button is-circle is-action"
                    @click="deleteUser(i)">
                    <i class="fal fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else-if="tab === 'INFO'"
          class="">
          <div
            class="is-padding">
            <div class="w50">
              <r-label
                label="Nom du groupe"
                for="name"
                :is-required="false"></r-label>
              <v-input
                id="name"
                name="name"
                :model="newName"
                @input="val => newName = val"
                v-validate="'required|min:2'"
                :errors-bag="errors"
                data-vv-value-path="val"
                data-vv-as="Nom du groupe">
              </v-input>
            </div>
          </div>
          <submit-sticky-buttons
            v-if="newName && newName !== group.name"
            :cancel="cancel"
            @submit="save"
            :loading="submitLoading"></submit-sticky-buttons>
        </div>
      </div>
    </page-content>
  </div>
</template>

<script>
import { Quickview } from '@/mixins'
import { mapState } from 'vuex'

export default {
  name: 'GroupVue',
  mixins: [Quickview],
  data () {
    return {
      submitLoading: false,
      newName: false,
      group: null,
      loading: false,
      tab: 'MEMBRES'
    }
  },
  computed: {
    ...mapState(['quickview', 'currentUser']),
    /**
      * pk of the group
      * @return {string}
      */
    groupPk () {
      return this.$route.params.id
    },
    /**
      * tabs
      * @return {array}
      */
    groupTabLinks () {
      let tab = [{ label: 'Membres', link: 'MEMBRES' }]
      if (!this.group.protected) {
        tab.push({ label: 'Informations', link: 'INFO' })
      }
      return tab
    }
  },
  watch: {
    quickview ({ mode, params, results }) {
      if (results) {
        if (mode === 'USER_SELECTION') {
          for (let user of results.entities) {
            this.addUsers(user)
          }
        } else if (mode === 'RELATION_SELECTION') {
          for (let contact of results.entities) {
            this.addContact(contact)
          }
        }
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    /**
      * init vue
      * get groupe and set name
      */
    async init () {
      await this.getGroup()
      this.$set(this, 'newName', this.group.name)
    },
    /**
      * cancel new name
      */
    cancel () {
      this.$set(this, 'newName', this.group.name)
    },
    /**
      * get group
      */
    async getGroup () {
      this.loading = true
      try {
        let { data } = await this.$api.getOne(this.$resources.GROUP, this.groupPk)
        this.group = data
        this.loading = false
      } catch (err) {
        console.log(err)
        this.loading = false
      }
    },
    /**
      * save group name
      */
    async save () {
      let group = Object.assign({}, this.group)
      if (this.newName) {
        group.name = this.newName
      }
      this.submitLoading = true
      try {
        await this.$api.put(this.$resources.GROUP, this.groupPk, group)
        this.submitLoading = false
        this.$toasted.global.success('Groupe enregistré')
        this.getGroup()
      } catch (err) {
        console.log(err)
        this.submitLoading = false
      }
    },
    /**
      * prepar algolia params then
      * open new user quickview
      */
    openAddNewMember () {
      if (this.group.is_commercial) {
        let userPk = this.group.users.map(x => x.pk)
        let params = {
          facets: {
            ACCOUNT: []
          },
          isCommercial: this.group.is_commercial,
          searchKeys: 'ACCOUNT',
          mode: 'store'
        }
        for (let pk of userPk) {
          params.facets.ACCOUNT.push([`pk:-${pk}`])
        }
        this.openRelationSelectionQuickview(params)
      } else {
        let userPk = this.group.users.map(x => x.pk)
        let params = {
          facets: {
            USER: []
          },
          isCommercial: this.group.is_commercial,
          searchKeys: 'USER',
          mode: 'store'
        }
        for (let pk of userPk) {
          params.facets.USER.push([`pk:-${pk}`])
        }
        this.openUserSelectionQuickview(params)
      }
    },
    /**
      * Confirm modal
      */
    confirmDelete () {
      return this.$swal({
        title: 'Retirer utilisateur du groupe',
        text: 'L\'utilisateur ne sera plus rattaché à ce groupe. Les statistiques de groupes seront actualisées avec ce nouveau paramètre.',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
        }
      })
    },
    /**
      * Delete user in group
      * @param {number} index - index of user
      */
    async deleteUser (index) {
      let value = await this.confirmDelete()
      if (value.dismiss) return false
      if (value) {
        let group = Object.assign({}, this.group)
        group.users.splice(index, 1)
        this.submitLoading = true
        try {
          await this.$api.put(this.$resources.GROUP, this.groupPk, group)
          this.submitLoading = false
          this.$toasted.global.success('Utilisateur supprimé du groupe')
          this.getGroup()
        } catch (err) {
          console.log(err)
          this.submitLoading = false
        }
      }
    },
    async addContact (contact) {
      let formatedContact = {
        ...contact.first_admin,
        account: null
      }
      // TODO back add field account
      let group = Object.assign({}, this.group)
      group.users.push(formatedContact)
      this.submitLoading = true
      try {
        await this.$api.put(this.$resources.GROUP, this.groupPk, group)
        this.submitLoading = false
        this.$toasted.global.success('Société ajouté au groupe')
        this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
        this.getGroup()
      } catch (err) {
        console.log(err)
        this.submitLoading = false
      }
    },
    /**
    * Add user in group
    * @param {object} user - user object
    */
    async addUsers (user) {
      let group = Object.assign({}, this.group)
      group.users.push(user)
      this.submitLoading = true
      try {
        await this.$api.put(this.$resources.GROUP, this.groupPk, group)
        this.submitLoading = false
        this.$toasted.global.success('Utilisateur ajouté au groupe')
        this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
        this.getGroup()
      } catch (err) {
        console.log(err)
        this.submitLoading = false
      }
    },
    /**
      * Delete groupe
      */
    async removeGroup () {
      let value = await this.confirmDeleteGroup()
      if (value.dismiss) return false
      if (value) {
        this.loading = true
        try {
          await this.$api.delete(this.$resources.GROUP, this.groupPk)
          this.$toasted.global.success('Suppression du groupe réussi')
          this.$router.push({ name: 'GroupListInterne' })
        } catch (e) {
          this.$toasted.global.danger('Erreur lors de la suppression')
        }
      }
    },
    async confirmDeleteGroup () {
      return this.$swal({
        title: 'Suppression du groupe',
        text: 'Le groupe sera supprimé définitivement',
        confirmButtonText: 'Supprimer',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
        }
      })
    }
  }
}
</script>
